module.exports = __webpack_public_path__ + "b873c9a9d24998cc5dd724f35eed5b2e.svg";